<template>
  <div class="home">
    <Header />
    <Customers />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "./Common/Header.vue";
import Customers from "@/components/Customers.vue";

export default {
  name: "customers",
  components: {
    Header,
    Customers
  }
};
</script>
